module.exports = __webpack_public_path__ + "img/20190611_153430_041.252f442f.jpg";